import actions from "./actions";
import mutations from "./mutations";

export default {
    namespaced: true,
    state() {
        return {
            queryKeys: ['vehicle_make_id','vehicle_model_id','vehicle_year_min','vehicle_year_max','condition_id', 'sort', 'visibility', 'stock_id'],
            inventoryVehicles: {
                data: [],
                meta: {},
            },
            loading: false,
        }
    },
    actions,
    mutations,
}
